if (!window.requestIdleCallback) {
    // @ts-expect-error -- poor man's polyfill
     
    window.requestIdleCallback = callback => {
        window.setTimeout(() => {
            callback({ didTimeout: true, timeRemaining: () => 1 });
        }, 0);
    };
}
